export default function getLanguageVersion(language, title, title_en) {
  if (language === 'en' && title_en) return title_en;
  if (language === 'en' && !title_en) return title;
  return title ?? '';
}
